export default __webpack_public_path__ + "images/44877486b0827dc56c382deac51f67a3-Eventbrite_Halloween_HomepageC_659x494.webp";